import React from "react";

const ContactMod = () => {


    return (

        <div className="container-fluid">
            <div className="modal fade" id="ContactMod" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-center">
                            <div className="text-center w-100">
                                <h5 className="modal-title modaltitlesize" id="exampleModalLongTitle">Contact Information</h5>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="text-center p-3">
                            <div className="row">
                                <div className="col-12">
                                    <img src="https://i.pinimg.com/originals/3a/d1/47/3ad147f2ec0525c8ac864f810a4161f3.jpg" 
                                    className="img-fluid rounded img-overlay" alt="Responsive image">
                                    </img>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body modaltextsize">
                            <div className="p-2">
                                <div className="">
                                        <div className="col-12">
                                            <i class="fa fa-user col-4 text-center" aria-hidden="true"></i>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            Scott Caputo
                                        </div>
                                </div>
                            </div>

                            <div className="p-2">
                                <div className="">
                                        <div className="col-12">
                                            <i class="fa fa-phone col-4 text-center" aria-hidden="true"></i>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            (813)-335-9002
                                        </div>
                                </div>
                            </div>

                            <div className="p-2">
                                <div className="">
                                        <div className="col-12">
                                            <i class="fa fa-envelope col-4 text-center" aria-hidden="true"></i>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            scottvcaputo@gmail.com
                                        </div>
                                </div>
                            </div>

                            <div className="p-2">
                                <div className="">
                                        <div className="col-12">
                                        <i class="fa fa-university col-4 text-center" aria-hidden="true"></i>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            svc2130@columbia.edu
                                        </div>
                                </div>
                            </div>


                        </div>
                        <div className="modal-footer">
                            <button type="button" 
                            className="btn btn-outline-dark p-2 m-2 col-md-2" 
                            data-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ContactMod;